import { HTMLAttributes } from 'react';

import clsx from 'clsx';

export interface InputLabelProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
  label: string;
  isRequired?: boolean;
}

const InputLabel = ({
  className,
  id,
  isRequired,
  label,
  ...props
}: InputLabelProps) => {
  return (
    <div className={clsx('text-p2 text-text-primary-inactive', className)} {...props}>
      <label className="flex flex-row gap-3xs items-center" htmlFor={id}>
        <span>{label}</span>
        {isRequired && <sup className="w-1 h-1 rounded-full bg-icon-error" />}
      </label>
    </div>
  );
};

export default InputLabel;
